import { ICustomerAccountDetails } from "../../../../../../../../custom-hooks/useCustomerAccountDetails";
import { formatMoney } from "../../../../../../../../helpers/formatter";
import { ROLE_TYPES } from "../../../../../../../../helpers/roleTypes";
import { useSelector, useDispatch } from "react-redux";
import { showModal } from "../../../../../../../../redux/actions/modal";
import { useLocation } from "react-router-dom";

import styles from "./general.module.scss";

interface IGeneralProps {
  data: ICustomerAccountDetails;
  accountNumber?: string;
  accountName?: string;
  walletId?: number;
}

const General = ({
  data: accountDetails,
  accountNumber,
  accountName,
  walletId,
}: IGeneralProps) => {
  let location: any = useLocation();

  let { email: customerEmail, walletProviderId } = location?.state;

  const dispatch = useDispatch();
  const loggedInUser = useSelector(
    (state: any) => state?.authReducer?.loggedInUser,
  );

  const hasDownloadPermission =
    loggedInUser?.roles &&
    loggedInUser?.roles?.length > 0 &&
    loggedInUser?.roles?.includes(ROLE_TYPES.GENERATE_CASA_BANK_STATEMENT);

  const handleDownloadStatement = () => {
    dispatch(
      showModal({
        modalIdentifier: "downloadaccountstatement",
        dataRecord: {
          accountId: walletId || "",
          accountNumber: accountNumber || accountDetails?.accountNumber || "",
          accountName: accountName || accountDetails?.product || "",
          customerEmail: customerEmail || "",
          walletProviderId,
        },
      }),
    );
  };

  return (
    <div className={styles.generalWrapper}>
      {hasDownloadPermission && (
        <div className={styles.downloadButtonContainer}>
          <button
            className="btn advancly-btn"
            onClick={handleDownloadStatement}
          >
            <i className="fas fa-download"></i>
            &nbsp; Download Statement
          </button>
        </div>
      )}

      <div className={styles.general}>
        <div className={styles.details}>
          <h1>Savings Details</h1>
          <div className={styles.cardInformation}>
            <div className={styles.cardItem}>
              <p>Activated On</p>
              <p className={styles.value}>{accountDetails?.activatedOn}</p>
            </div>
            <div className={styles.cardItem}>
              <p>Officer Assigned</p>
              <p className={styles.value}>{accountDetails?.officerAssigned}</p>
            </div>{" "}
            <div className={styles.cardItem}>
              <p>Total Interest Earned</p>
              <p className={styles.value}>
                {accountDetails?.totalInterestEarned}
              </p>
            </div>
          </div>
        </div>

        <div className={styles.details}>
          <h1>Account Summary</h1>
          <div className={styles.cardInformation}>
            <div className={styles.cardItem}>
              <p>Total Withdrawals</p>
              <p className={styles.value}>
                {formatMoney(accountDetails?.totalWithdrawals)}
              </p>
            </div>
            <div className={styles.cardItem}>
              <p>Interest Earned</p>
              <p className={styles.value}>
                {formatMoney(accountDetails?.interestEarned)}
              </p>
            </div>{" "}
            <div className={styles.cardItem}>
              <p>Nominal Interest Rate</p>
              <p className={styles.value}>
                {formatMoney(accountDetails?.nominalInterestRate)}
              </p>
            </div>
          </div>
        </div>

        <div className={styles.details}>
          <h1>Performance History</h1>
          <div className={styles.cardInformation}>
            <div className={styles.cardItem}>
              <p>Total Deposits</p>
              <p className={styles.value}>
                {formatMoney(accountDetails?.totalDeposits)}
              </p>
            </div>
            <div className={styles.cardItem}>
              <p>Total Interest Earned</p>
              <p className={styles.value}>
                {formatMoney(accountDetails?.totalInterestEarned)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default General;
